import React from "react";
import { Button } from "../../Components/UI/Stateful-Button";
import { FaFlag } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="h-screen mx-auto grid place-items-center text-center px-8">
      <div>
        <FaFlag className="w-20 h-20 mx-auto" />
        <h1 className="mt-10 !text-3xl !leading-snug md:!text-4xl">
          Error 404 <br /> მოხვდით არასწორ გვერდზე
        </h1>
        <h1 className="mt-8 mb-14 text-[18px] font-normal text-gray-500 mx-auto md:max-w-sm">
          უბრალოდ დააჭირეთ ქვემოთ მოცემულ ღილაკს და დაბრუნდით მთავარ გვერდზე
        </h1>
        <button
          onClick={() => navigate("/")}
          className="w-36 h-14 relative text-white cursor-pointer outline-none 
 border-none bg-[#0c0c0c] text-base font-bold text-center rounded-[10px] 
 overflow-hidden duration-300 ease-in-out hover:[text-shadow:0px_5px_10px_var(--tw-shadow-color)] 
 shadow-[rgba(0, 0, 0, 0.562)] hover:scale-[1.01] hover:shadow-[inset_0px_0px_10px_rgb(59,59,59)] 
 after:content-[''] after:absolute after:top-0 after:left-[-100px] after:w-3/6 after:h-full 
 after:rotate-[80deg] after:bg-[#ffffff77] after:blur-[10px] after:duration-[0.6s] 
 after:ease-in-out hover:after:left-full font-Mtavruli text-3xl"
        >
          უკან -
        </button>
      </div>
    </div>
  );
};

export default NotFound;
